<template>
    <v-container class="pa-5" fluid>
        <v-row align="center" dense>
            <v-col cols="auto">
                <page-title>Etykiety / Historia wydruków</page-title>
            </v-col>
        </v-row>
        <v-row align="center">
            <v-col class="pb-0">
                <v-btn
                    text
                    color="primary"
                    class="pa-0"
                    @click="close"
                >
                    <v-icon color="primary">
                        mdi-arrow-left
                    </v-icon>
                    Powrót do listy
                </v-btn>
            </v-col>
        </v-row>
        <v-row justify="end">
            <v-col cols="8">
                <v-container fluid class="pa-0">
                    <v-row dense justify="end">
                        <v-col cols="12" md="4">
                            <v-autocomplete
                                v-model="filters.user_id"
                                :items="users"
                                :filter="customUsersFilter"
                                :loading="usersSearchLoading"
                                :search-input.sync="usersSearch"
                                label="Użytkownik"
                                class="v-text-field--placeholder-dark"
                                required
                                solo
                                hide-details
                                item-value="id"
                                no-data-text="Nie znaleziono"
                                clearable
                                @keyup.enter="changeFilter"
                                @input="changeFilter"
                                @click:clear="clearFilter('user_id')"
                            >
                                <template slot="no-data">
                                    <v-list-item>
                                        <v-list-item-title>
                                            <template v-if="!usersSearch">
                                                Wpisz treść aby odnaleźć <strong>użytkownika</strong>.
                                            </template>
                                            <template v-else-if="usersSearchLoading">
                                                Trwa wyszukiwanie...
                                            </template>
                                            <template v-else>
                                                Nie znaleziono
                                            </template>
                                        </v-list-item-title>
                                    </v-list-item>
                                </template>
                                <template slot="selection" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                                <template slot="item" slot-scope="data">
                                    <template v-if="data.item.firstName && data.item.lastName">
                                        {{ data.item.firstName }} {{ data.item.lastName }}
                                    </template>
                                    <template v-else>
                                        {{ data.item.username }}
                                    </template>
                                </template>
                            </v-autocomplete>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu
                                v-model="menuFrom"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.createdAt__gte"
                                        label="Od"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        solo
                                        hide-details
                                        append-icon
                                        clearable
                                        class="mt-0"
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('createdAt__gte')"
                                    >
                                        <template slot="append-outer">
                                            <div class="d-flex flex-wrap">
                                                <v-btn
                                                    icon
                                                    x-small
                                                    class="mt-n2"
                                                    data-sentry-label="Zmiana daty początku zakresu historii wydruków etykiet"
                                                    @click="getForwardDate('startDateTime__gte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-up
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn
                                                    icon
                                                    x-small
                                                    data-sentry-label="Zmiana daty początku zakresu historii wydruków etykiet"
                                                    @click="getBackwardDate('createdAt__gte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-down
                                                    </v-icon>
                                                </v-btn>
                                            </div>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filters.createdAt__gte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="menuFrom = false"
                                />
                            </v-menu>
                        </v-col>
                        <v-col cols="12" md="4">
                            <v-menu
                                v-model="menuTo"
                                :close-on-content-click="false"
                                :nudge-right="40"
                                transition="scale-transition"
                                offset-y
                                min-width="290px"
                            >
                                <template #activator="{on}">
                                    <v-text-field
                                        v-model="filters.createdAt__lte"
                                        label="Do"
                                        prepend-icon="mdi-calendar"
                                        readonly
                                        solo
                                        hide-details
                                        append-icon
                                        clearable
                                        class="mt-0"
                                        v-on="on"
                                        @input="changeFilter"
                                        @click:clear="clearFilter('createdAt__lte')"
                                    >
                                        <template slot="append-outer">
                                            <div class="d-flex flex-wrap">
                                                <v-btn
                                                    icon
                                                    x-small
                                                    class="mt-n2"
                                                    data-sentry-label="Zmiana daty końca zakresu historii wydruków etykiet"
                                                    @click="getForwardDate('createdAt__lte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-up
                                                    </v-icon>
                                                </v-btn>
                                                <v-btn
                                                    icon
                                                    x-small
                                                    data-sentry-label="Zmiana daty końca zakresu historii wydruków etykiet"
                                                    @click="getBackwardDate('createdAt__lte')"
                                                >
                                                    <v-icon>
                                                        mdi-chevron-down
                                                    </v-icon>
                                                </v-btn>
                                            </div>
                                        </template>
                                    </v-text-field>
                                </template>
                                <v-date-picker
                                    v-model="filters.createdAt__lte"
                                    first-day-of-week="1"
                                    @change="changeFilter"
                                    @input="menuTo = false"
                                />
                            </v-menu>
                        </v-col>
                    </v-row>
                </v-container>
            </v-col>
        </v-row>

        <v-row>
            <v-col cols="12">
                <v-card>
                    <v-data-table
                        :headers="headers"
                        :items="labelsHistory"
                        :loading="labelsLoading"
                        :footer-props="footerProps"
                        :server-items-length="pagination.itemsLength"
                        :page.sync="pagination.page"
                        :items-per-page.sync="pagination.itemsPerPage"
                        :mobile-breakpoint="0"
                        name="labelsData"
                        @pagination="updatePagination"
                    >
                        <template #item.printedBy="{item}">
                            {{ item.printedBy.firstName }} {{ item.printedBy.lastName }}
                        </template>
                        <template #item.createdAt="{item}">
                            {{ formatDate(item.createdAt) }}
                        </template>
                        <template #item.type="{item}">
                            {{ item.labelType.name }}
                        </template>
                        <template #item.shopName="{item}">
                            {{ item.shopName }}
                        </template>
                        <template #item.quantity="{item}">
                            {{ item.quantity }}
                        </template>
                        <template #item.fileName="{item}">
                            {{ item.fileName }}
                        </template>
                    </v-data-table>
                </v-card>
            </v-col>
        </v-row>
    </v-container>
</template>

<script>
import router from '@/router'

import PageTitle from '@/components/common/PageTitle'
import dateFormatter from '@/mixins/dateFormatter'
import customFilters from '@/mixins/customFilters'
import tooltipDelay from '@/mixins/tooltip'
import dataTableClassSetter from '@/mixins/dataTableClassSetter'
import pagination from '@/mixins/dataTablePagination'
import filters from '@/mixins/dataTableFilters'
import { errorHandler, addSentryBreadcrumb } from '@/utils/errorHandler'

let searchTimer

export default {
    name: 'LabelPrintHistory',
    components: {
        PageTitle,
    },
    mixins: [
        dateFormatter,
        tooltipDelay,
        pagination,
        filters,
        dataTableClassSetter,
        customFilters
    ],
    beforeRouteLeave(to, from, next) {
        this.resetFiltersCleared()
        next()
    },
    data() {
        return {
            usersSearch: null,
            menuFrom: false,
            menuTo: false,
            usersSearchLoading: false,
            users: [],
            headers: [
                {
                    text: 'Drukujący',
                    value: 'printedBy',
                    sortable: false,
                },
                {
                    text: 'Data wydruku',
                    value: 'createdAt',
                    sortable: false,
                    align: 'center',
                },
                {
                    text: 'Typ etykiety',
                    value: 'labelType.name',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Klient',
                    value: 'shopName',
                    sortable: false,
                    align: 'center'
                },
                {
                    text: 'Ilość',
                    value: 'quantity',
                    align: 'center',
                    sortable: false,
                },
                {
                    text: 'Nazwa pliku',
                    value: 'fileName',
                    align: 'center',
                    sortable: false,
                },
            ]
        }
    },
    computed: {
        labelsLoading() {
            return this.$store.state.shipments.sendings.sendings.labelsPrintHistoryElementsLoading
        },
        labelsHistory() {
            return this.$store.state.shipments.sendings.sendings.labelsPrintHistoryElements
        },
        filterQuery() {
            const filters = Object.assign({}, this.filters)
            let query = ''

            for (let item in filters) {
                if (filters[item] !== null && filters[item] != undefined) {
                    if (item == 'createdAt__gte') {
                        filters[item] += 'T00:00:00Z'
                    }

                    if (item == 'createdAt__lte') {
                        filters[item] += 'T23:59:59Z'
                    }

                    query = query.concat('&', `${item}=${filters[item]}`)
                }
            }

            return query
        },
    },
    watch: {
        usersSearch(value = null) {
            if (value === null) return

            this.usersSearchLoading = true

            clearTimeout(searchTimer)

            searchTimer = setTimeout(() => {
                if (value) {
                    this.searchUsers(value)
                } else {
                    this.usersSearchLoading = false
                    this.users = []
                }
            }, 500)
        },
    },
    beforeMount() {
        if (!this.savedPagination.pagination) {
            this.resetPagination()
        }
    },
    mounted() {
        this.getLabelsHistory()
    },
    methods: {
        searchUsers(query = '') {
            addSentryBreadcrumb('ui.action', 'Wyszukiwanie użytkownika')

            this.$store.dispatch('administration/findUsers', {
                paginate: '?limit=20',
                query: query
            })
                .then(response => {
                    this.users = response.data.results
                })
                .catch(error => {
                    errorHandler(error)
                })
                .finally(() => {
                    this.usersSearchLoading = false
                })
        },
        getBackwardDate(date) {
            if (Date.parse(this.filters[date])) {
                this.filters[date] = this.getDayBackward(this.filters[date])
                this.changeFilter()
            }
        },
        getForwardDate(date) {
            if (Date.parse(this.filters[date])) {
                this.filters[date] = this.getDayForward(this.filters[date])
                this.changeFilter()
            }
        },
        getLabelsHistory() {
            this.$store.dispatch('shipments/sendings/getShippingLabelsPrintHistory', {
                paginate: this.paginate(),
                query: this.filterQuery
            })
                .then(response => {
                    this.handlePaginationResponse(response)
                })
                .catch(error => {
                    errorHandler(error)
                })
        },
        close() {
            router.push({ name: 'shipmentsLabelsGenerator' })
                .catch(error => {
                    errorHandler(error)
                })
        },
        changeFilter() {
            this.$store.dispatch('shipments/sendings/setShippingLabelsPrintHistoryFilters', this.filters)
                .catch(error => {
                    errorHandler(error)
                })
            this.resetPagination()

            /* With below modification, when the user interacts with filters,
            the changeFilter method will be called immediately. However,
            the actual data fetching will be delayed */

            clearTimeout(this.filterTimeout)
            
            this.filterTimeout = setTimeout(() => {
                this.getLabelsHistory()
            }, 300)
        },
        updatePagination(pagination) {
            this.pagination = pagination
            this.evaluateSavedPagination(this.$options.name)

            if (pagination.pageCount !== 0 && !this.paginationSettings.paginationPending && !this.savedPagination.pagination) {
                this.getLabelsHistory()
            }
            this.clearPaginationPending()
        },
    }
}
</script>
